export const SeeAllLinkVariants = {
  REGULAR: 'regular',
  /* Keeps the original casing and underlines only on hover */
  SUBTLE: 'subtle'
};
